import { t } from '@lingui/macro';
import { PhoneNumberField } from 'shared/domains/forms/components/PhoneNumberField';
export function MobileField() {
    return (<PhoneNumberField stretch name="mobile" label={t({ message: 'Mobile', comment: 'Label for mobile number input field' })}/>);
}
